<template>
  <nav
    :class="
      `ims-toolbar bg-${color} ${
        inverse ? 'text-light' : 'text-dark'
      } size-${size}`
    "
  >
    <div class="left" v-if="slotExists('left')">
      <slot name="left" />
    </div>
    <div :class="`middle ${slotExists('right') || slotExists('left') ? 'pad' : ''}`">
      <slot />
    </div>
    <div class="right" v-if="slotExists('right')">
      <slot name="right" />
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default() {
        return 'lg';
      }
    },
    inverse: {
      type: Boolean,
      default() {
        return false;
      }
    },
    color: {
      type: String,
      default() {
        return 'white';
      }
    }
  },
  methods: {
    slotExists(name) {
      if (name) {
        return this.$slots.hasOwnProperty(name);
      } else {
        return this.$slots.hasOwnProperty('default');
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
@import '../../scss/vendors/bootstrap-utils';

.ims-toolbar {
  display: flex;
  flex-direction: row;
  padding-left: 16px;
  padding-right: 16px;
  align-items: center;
  min-width: 100%;
  position: relative;
  justify-content: center;
  flex-shrink: 0;

  &.hidden {
    display: none;
  }
  .middle {
    text-align: center;
    line-height: 110% !important;
    flex-grow: 1;
    flex-shrink: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .middle.pad {
    margin-left: 30px;
    margin-right: 30px;
  }

  .title {
    font-size: $font-lg;
    line-height: $font-lg;
    font-weight: 700;
    text-align: center;
    &.md {
      font-size: $font-md;
      line-height: 110%;
    }
  }
  .note {
    opacity: 0.6;
    display: block;
    font-size: $font-sm;
    font-weight: 400;
    line-height: $font-sm * 1.4;
  }

  &.size-lg {
    height: $size-toolbar-height-lg;
  }
  &.size-sm {
    height: $size-toolbar-height-sm;
  }
  &.size-md {
    height: 45px;
  }
  .left {
    position: absolute;
    left: 10px;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .right {
    position: absolute;
    right: 16px;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  &.bg-white {
    color: #333;
  }
}
</style>
